
import {
  Object3D,
  MeshBasicMaterial,
  NormalBlending,
  Mesh,
  TextureLoader,
  PlaneBufferGeometry
} from "three";

import { AnimationController } from "./AnimationController";

const textureLoader = new TextureLoader();

export class Hotspot3D extends Object3D {
  public static RADIUS = 1;

  private planeMaterial:MeshBasicMaterial;
  private waveMaterialA:MeshBasicMaterial;
  private waveMaterialB:MeshBasicMaterial;

  public onClick:(()=>void)|undefined;

  public get opacity():number {
    return this._opacity;
  }

  public set opacity(value:number) {
    this._opacity = value;
    this.updateOpacity();
  }

  public set size(value:number) {
    this._size = value;
    this.updateScale();
  }

  private _opacity:number = 1;
  private _size:number = 1;
  private _animationScale:number = 1;
  private _animationOpacityA:number = 0;
  private _animationOpacityB:number = 0;

  public constructor(
    interactionHotspot:boolean,
    private animationController:AnimationController,
    onClick:(()=>void)|undefined
  ) {
    super();

    if (interactionHotspot) {
      let t = 0;
      setInterval(() => {
        this._animationScale = 1 + Math.sin(t) * 0.1;
        this.updateScale();
        t += 0.05;
      }, 1000/60)
    }

    this.planeMaterial = new MeshBasicMaterial({
      map: textureLoader.load(`${HASH}/textures/hotspot${interactionHotspot ? '-interaction' : ''}.png`),
      transparent: true,
      alphaTest: 0,
      blending: NormalBlending,
      toneMapped: false,
      depthTest: false
    });

    const radius = Hotspot3D.RADIUS * (interactionHotspot ? 0.7 : 1);

    const plane = new Mesh(new PlaneBufferGeometry(radius, radius), this.planeMaterial);
    this.add(plane);

    this.waveMaterialA = new MeshBasicMaterial({
      map: textureLoader.load(`${HASH}/textures/hotspot-layer.png`),
      transparent: true,
      alphaTest: 0,
      blending: NormalBlending,
      toneMapped: false,
      depthTest: false
    });
    const waveA = new Mesh(new PlaneBufferGeometry(radius, radius), this.waveMaterialA);
    this.add(waveA);

    this.waveMaterialB = this.waveMaterialA.clone();
    const waveB = new Mesh(new PlaneBufferGeometry(radius, radius), this.waveMaterialB);
    this.add(waveB);

    if (onClick) {
      this.onClick = () => {
        this._animationOpacityA = 1;
        this._animationOpacityB = 0;
        this.updateOpacity();

        // Reset scale
        waveA.scale.x = 0.8;
        waveA.scale.y = 0.8;
        waveB.scale.x = 0.8;
        waveB.scale.y = 0.8;

        let secondWave = false;
        setTimeout(() => {
          this._animationOpacityB = 1;
          secondWave = true
        }, 100);

        const interval = setInterval(() => {
          if (this._animationOpacityA > 0) {
            this._animationOpacityA = Math.max(0, this._animationOpacityA - 0.1);
            waveA.scale.x += 0.15;
            waveA.scale.y += 0.15;
          }

          if (secondWave) {
            if (this._animationOpacityB > 0) {
              this._animationOpacityB = Math.max(0, this._animationOpacityB - 0.05);
              waveB.scale.x += 0.08;
              waveB.scale.y += 0.08;
            } else {
              // Avoid intersection issues with hotspot click
              waveA.scale.x = 0;
              waveB.scale.x = 0;

              clearInterval(interval);
            }
          }

          this.updateOpacity();
        }, 16);

        onClick();
      }
    }
  }

  private updateScale():void {
    this.scale.setScalar(this._size * this._animationScale);
  }

  private updateOpacity():void {
    this.planeMaterial.opacity = this.opacity;
    this.waveMaterialA.opacity = this.opacity * this._animationOpacityA;
    this.waveMaterialB.opacity = this.opacity * this._animationOpacityB * 0.25;
  }
}